import React, { useEffect } from 'react';
import {
  UPSERT_INCOME_FORM_ID,
  UpsertIncomeFormProps,
} from '../../components/UpsertIncomeModal/UpsertIncomeModal.meta';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { useOtherIncomeForm } from './useOtherIncomeForm';
import { OtherIncomeFormFields } from './OtherIncomeFormFields';

export type Props = UpsertIncomeFormProps;

export const OtherIncomeForm = ({
  clientId,
  income,
  data,
  onSuccess,
  onDirtyChange,
  readOnly,
}: Props) => {
  const {
    data: { formBag, defaultShowAdvanced, mutationBag },
    actions: { onSubmit, resetValues },
  } = useOtherIncomeForm({ clientId, income, data, onSuccess, readOnly });

  const {
    formState: { isDirty },
  } = formBag;

  useEffect(() => {
    onDirtyChange?.(isDirty);
  }, [isDirty, onDirtyChange]);

  useEffect(() => {
    resetValues();
  }, [income, resetValues]);

  return (
    <form
      onSubmit={onSubmit}
      id={UPSERT_INCOME_FORM_ID}
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
      aria-label="Other income form"
    >
      {mutationBag.error && (
        <Alert
          variant="error"
          message={mutationBag.error.message}
          onRequestClose={mutationBag.reset}
        />
      )}

      <OtherIncomeFormFields
        formBag={formBag}
        options={data.Options}
        defaultShowAdvanced={defaultShowAdvanced}
      />
    </form>
  );
};
